<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>生产管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应商价格档案</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 供应商价格档案 strat -->
      <el-tab-pane name="first" label="供应商价格档案">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select">
              <el-option label="请选择审核状态" value="-1"></el-option>
              <el-option label="采购已录入" value="1"></el-option>
              <el-option label="财务已审核" value="2"></el-option>
              <el-option label="总经理已审核" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickexcel()">导出</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="JigouName" label="所属公司名称" min-width="6%"></el-table-column>
          <el-table-column prop="Statuss" label="审核状态" min-width="7%"></el-table-column>
          <el-table-column prop="Productname" label="材料名称" min-width="6%"></el-table-column>
          <el-table-column prop="Productbomsn" label="材料编号" min-width="6%"></el-table-column>
          <el-table-column prop="Suppliername" label="供应商名称" min-width="6%"></el-table-column>
          <el-table-column prop="Contactname" label="供应商联系人" min-width="6%"></el-table-column>
          <el-table-column prop="Contactphone" label="供应商联系方式" min-width="6%"></el-table-column>
          <el-table-column prop="Socialcreditcode" label="供应商社会信用代码" min-width="6%"></el-table-column>
          <el-table-column prop="Paymentperiod" label="供应商付款周期" min-width="5%"></el-table-column>
          <el-table-column prop="Bankname" label="供应商开户行" min-width="5%"></el-table-column>
          <el-table-column prop="Banknumber" label="供应商账号" min-width="5%"></el-table-column>
          <el-table-column prop="Pricetax" label="含税价" min-width="5%"></el-table-column>
          <el-table-column prop="Pricenotax" label="未税价" min-width="5%"></el-table-column>
          <el-table-column prop="Rate" label="税率" min-width="5%"></el-table-column>
          <el-table-column label="合同附件" min-width="8%">
            <template v-slot="scope">
              <el-button v-for="Fileurl in scope.row.Fileurls" type="text" @click="clickfile(Fileurl)">点击查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="Operation" min-width="9%" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1" @click="clickedit(scope.$index,scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1" @click="clickdelete(scope.$index,scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1 && SubRule_ProductMoneySupplier_Caiwu" @click="clickShenHe(2,scope.row)">财务审核</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 2 && SubRule_ProductMoneySupplier_ZongJingLi" @click="clickShenHe(3,scope.row)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

        <!-- 编辑供应商价格档案弹出框 start -->
        <el-dialog title="编辑供应商价格档案" :visible.sync="editdialog" width="40%" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editFormRef" label-width="140px">
            <el-form-item label="供应商名称" class="addAdminForm">
              <el-input v-model="editForm.suppliername" placeholder="请输入供应商名称"></el-input>
            </el-form-item>
            <el-form-item label="供应商联系人" class="addAdminForm">
              <el-input v-model="editForm.contactname" placeholder="请输入供应商联系人"></el-input>
            </el-form-item>
            <el-form-item label="供应商联系方式" class="addAdminForm">
              <el-input v-model="editForm.contactphone" placeholder="请输入供应商联系方式"></el-input>
            </el-form-item>
            <el-form-item label="供应商社会信用代码" class="addAdminForm">
              <el-input v-model="editForm.socialcreditcode" placeholder="请输入供应商社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="供应商付款周期" class="addAdminForm">
              <el-input v-model="editForm.paymentperiod" placeholder="请输入供应商付款周期"></el-input>
            </el-form-item>
            <el-form-item label="供应商开户行" class="addAdminForm">
              <el-input v-model="editForm.bankname" placeholder="请输入供应商付款周期"></el-input>
            </el-form-item>
            <el-form-item label="供应商账号" class="addAdminForm">
              <el-input v-model="editForm.banknumber" placeholder="请输入供应商付款周期"></el-input>
            </el-form-item>
            <el-form-item label="含税价" class="addAdminForm">
              <el-input v-model="editForm.pricetax" placeholder="请输入含税价" @change="processpricenotaxEdit()"></el-input>
            </el-form-item>
            <el-form-item label="税率" class="addAdminForm">
              <el-input v-model="editForm.rate" placeholder="请输入税率" @change="processpricenotaxEdit()"></el-input>
            </el-form-item>
            <el-form-item label="未税价" class="addAdminForm">
              <el-input v-model="editForm.pricenotax" placeholder="请输入未税价" disabled></el-input>
            </el-form-item>
            <el-form-item class="addAdminForm">
              <label slot="label">
                <span style="color: #FF0000;">合同附件(必填)</span>
              </label>
              <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="editTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="funsaveedit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑供应商价格档案弹出框 end -->
      </el-tab-pane>
      <!-- 供应商价格档案 end -->

      <!-- 添加供应商价格档案 start -->
      <el-tab-pane name="second" label="添加供应商价格档案" v-if="SubRule_ProductMoneySupplier_Add">
        <el-form :model="addForm" ref="addFormRef" label-width="140px">
          <el-form-item label="材料编号" class="addAdminForm">
            <el-input v-model="addForm.bomsn" placeholder="请输入材料编号"></el-input>
            <el-button type="success" plain @click="apiCheckProjectbom">校验</el-button>
            <li>项目名称：{{addForm.parentname}}</li>
            <li>材料名称：{{addForm.name}}</li>
          </el-form-item>
          <el-form-item label="供应商名称" class="addAdminForm">
            <el-input v-model="addForm.suppliername" placeholder="请输入供应商名称"></el-input>
            <el-button type="success" plain @click="apiCheckproductmoneysupplier">自动填充</el-button>
          </el-form-item>
          <el-form-item label="供应商联系人" class="addAdminForm">
            <el-input v-model="addForm.contactname" placeholder="请输入供应商联系人"></el-input>
          </el-form-item>
          <el-form-item label="供应商联系方式" class="addAdminForm">
            <el-input v-model="addForm.contactphone" placeholder="请输入供应商联系方式"></el-input>
          </el-form-item>
          <el-form-item label="供应商社会信用代码" class="addAdminForm">
            <el-input v-model="addForm.socialcreditcode" placeholder="请输入供应商社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="供应商付款周期" class="addAdminForm">
            <el-input v-model="addForm.paymentperiod" placeholder="请输入供应商付款周期"></el-input>
          </el-form-item>
          <el-form-item label="供应商开户行" class="addAdminForm">
            <el-input v-model="addForm.bankname" placeholder="请输入供应商开户行"></el-input>
          </el-form-item>
          <el-form-item label="供应商账号" class="addAdminForm">
            <el-input v-model="addForm.banknumber" placeholder="请输入供应商账号"></el-input>
          </el-form-item>
          <el-form-item label="含税价" class="addAdminForm">
            <el-input v-model="addForm.pricetax" placeholder="请输入含税价" @change="processpricenotaxAdd()"></el-input>
          </el-form-item>
          <el-form-item label="税率" class="addAdminForm">
            <el-input v-model="addForm.rate" placeholder="请输入税率" @change="processpricenotaxAdd()"></el-input>
          </el-form-item>
          <el-form-item label="未税价" class="addAdminForm">
            <el-input v-model="addForm.pricenotax" placeholder="请输入未税价" disabled></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">合同附件(必填)</span>
            </label>
            <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="funsaveadd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加供应商价格档案 end -->

    </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    TencentyunCosUploadMultiImgOrPdf
  },
  name: 'MyProductMoneySupplier',
  data () {
    return {
      keywords: {
        jigouid: '-1',
        jigouname: '',
        status: '-1',
        bomsn: ''
      },
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      addForm: {
        parentid: 14,
        bomsn: '',
        parentname: '',
        name: '',
        suppliername: '',
        contactname: '',
        contactphone: '',
        socialcreditcode: '',
        paymentperiod: '',
        bankname: '',
        banknumber: '',
        pricetax: '',
        pricenotax: '',
        rate: '',
        fileurl: ''
      },
      editForm: {
        id: 0,
        suppliername: '',
        contactname: '',
        contactphone: '',
        socialcreditcode: '',
        paymentperiod: '',
        bankname: '',
        banknumber: '',
        pricetax: '',
        pricenotax: '',
        rate: '',
        fileurl: ''
      },
      editdialog: false,
      SubRule_ProductMoneySupplier_Add: false,
      SubRule_ProductMoneySupplier_Caiwu: false,
      SubRule_ProductMoneySupplier_ZongJingLi: false
    }
  },
  mounted () {
    this.apiGetproductmoneysuppliernum()
    this.apiGetproductmoneysupplierlist()

    this.addForm.effectivedate = Vue.prototype.FunGetTimeStringLong()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoneySupplier_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoneySupplier_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoneySupplier_Caiwu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoneySupplier_Caiwu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoneySupplier_ZongJingLi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoneySupplier_ZongJingLi = true
      }
    })
  },
  methods: {
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.fileurl = url
    },
    editTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.fileurl = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    processpricenotaxAdd () {
      this.addForm.pricenotax = this.processpricenotax(this.addForm.pricetax, this.addForm.rate)
    },
    processpricenotaxEdit () {
      this.editForm.pricenotax = this.processpricenotax(this.editForm.pricetax, this.editForm.rate)
    },
    processpricenotax (pricetax, rate) {
      var pricetaxf = Number(pricetax)
      var ratef = Number(rate.replace('%', ''))
      var rv = pricetaxf / (1 + ratef / 100)
      return rv.toFixed(3)
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetproductmoneysupplierlist()
    },
    handleClick (tab, event) {
      this.addForm.bomsn = ''
      this.addForm.parentname = ''
      this.addForm.name = ''
      this.addForm.suppliername = ''
      this.addForm.contactname = ''
      this.addForm.contactphone = ''
      this.addForm.socialcreditcode = ''
      this.addForm.paymentperiod = ''
      this.addForm.bankname = ''
      this.addForm.banknumber = ''
      this.addForm.pricetax = ''
      this.addForm.pricenotax = ''
      this.addForm.rate = ''
      this.addForm.fileurl = ''
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetproductmoneysuppliernum()
      this.apiGetproductmoneysupplierlist()
    },
    clickexcel () {
      this.apiExcelProductMoneySupplier()
    },
    clickdelete (index, row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteproductmoneysupplier(row.Id)
      })
    },
    funsaveadd () {
      if (!this.addForm.suppliername) {
        this.$alert('请输入供应商名称', '提示')
        return
      }
      if (!this.addForm.pricetax) {
        this.$alert('请输入含税价', '提示')
        return
      }
      if (!this.addForm.pricenotax) {
        this.$alert('请输入未税价', '提示')
        return
      }
      if (!this.addForm.rate) {
        this.$alert('请输入税率', '提示')
        return
      }
      if (!this.addForm.fileurl) {
        this.$alert('请上传合同附件', '提示')
        return
      }
      this.apiAddproductmoneysupplier()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (index, row) {
      this.editForm.id = row.Id
      this.editForm.suppliername = row.Suppliername
      this.editForm.contactname = row.Contactname
      this.editForm.contactphone = row.Contactphone
      this.editForm.socialcreditcode = row.Socialcreditcode
      this.editForm.paymentperiod = row.Paymentperiod
      this.editForm.bankname = row.Bankname
      this.editForm.banknumber = row.Banknumber
      this.editForm.pricetax = row.Pricetax
      this.editForm.pricenotax = row.Pricenotax
      this.editForm.rate = row.Rate
      this.editForm.fileurl = row.Fileurl
      this.editdialog = true
    },
    clickShenHe (status, row) {
      this.$confirm('是否同意该价格档案?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditproductmoneysuppliershenhe(status, row.Id)
      })
    },
    funsaveedit () {
      if (!this.editForm.suppliername) {
        this.$alert('请输入供应商名称', '提示')
        return
      }
      if (!this.editForm.pricetax) {
        this.$alert('请输入含税价', '提示')
        return
      }
      if (!this.editForm.pricenotax) {
        this.$alert('请输入未税价', '提示')
        return
      }
      if (!this.editForm.rate) {
        this.$alert('请输入税率', '提示')
        return
      }
      if (!this.editForm.fileurl) {
        this.$alert('请上传合同附件', '提示')
        return
      }
      this.apiEditproductmoneysupplier()
    },
    apiAddproductmoneysupplier: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        suppliername: this.addForm.suppliername,
        contactname: this.addForm.contactname,
        contactphone: this.addForm.contactphone,
        socialcreditcode: this.addForm.socialcreditcode,
        paymentperiod: this.addForm.paymentperiod,
        bankname: this.addForm.bankname,
        banknumber: this.addForm.banknumber,
        pricetax: this.addForm.pricetax,
        pricenotax: this.addForm.pricenotax,
        rate: this.addForm.rate,
        fileurl: this.addForm.fileurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductmoneysupplier, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetproductmoneysuppliernum()
            that.apiGetproductmoneysupplierlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetproductmoneysupplierlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductmoneysupplierlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Fileurls = that.dataList[i].Fileurl.split('@@@')
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetproductmoneysuppliernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductmoneysuppliernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditproductmoneysupplier: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        suppliername: this.editForm.suppliername,
        contactname: this.editForm.contactname,
        contactphone: this.editForm.contactphone,
        socialcreditcode: this.editForm.socialcreditcode,
        paymentperiod: this.editForm.paymentperiod,
        bankname: this.editForm.bankname,
        banknumber: this.editForm.banknumber,
        pricetax: this.editForm.pricetax,
        pricenotax: this.editForm.pricenotax,
        rate: this.editForm.rate,
        fileurl: this.editForm.fileurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductmoneysupplier, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetproductmoneysupplierlist()
          }
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteproductmoneysupplier: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteproductmoneysupplier, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetproductmoneysuppliernum()
            that.apiGetproductmoneysupplierlist()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditproductmoneysuppliershenhe: function (status, id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id,
        status: status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductmoneysuppliershenhe, Qs.stringify(data))
        .then(function (response) {
          that.apiGetproductmoneysupplierlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCheckProjectbom: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.addForm.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckProjectbom, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.addForm.bomsn = response.data.Bomsn
            that.addForm.parentname = response.data.Parentname
            that.addForm.name = response.data.Name
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCheckproductmoneysupplier: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        suppliername: that.addForm.suppliername
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Checkproductmoneysupplier, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.addForm.suppliername = response.data.Suppliername
            that.addForm.contactname = response.data.Contactname
            that.addForm.contactphone = response.data.Contactphone
            that.addForm.socialcreditcode = response.data.Socialcreditcode
            that.addForm.paymentperiod = response.data.Paymentperiod
            that.addForm.bankname = response.data.Bankname
            that.addForm.banknumber = response.data.Banknumber
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelProductMoneySupplier: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelProductMoneySupplier, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
.select2{
    width: 100%;
}
</style>
